import { SharedConstants } from "../../../shared/constants/shared.constants";
export class ApplyAccessConstants {
    static APPLY_SUCCESS_TEXT = "You have successfully applied to organisation";
    static MAIN_HEADING_TEXT = "Apply For Organisation Access";
    static SELECT_ORG_LABEL = "Select Organisation";
    static SELECT_ORG_TEXT = SharedConstants.PLACEHOLDER_TEXT;
    static ERROR_MESSAGE_OBJECT = "Apply to Organisation";
    static USER_APPLIED_MESSAGE = "You already applied to organisation";
    static ORGANISATION_SUSPENDED_TEXT = `Organisation ${SharedConstants.ITEM_SUSPENDED}`;
    static CHOOSE_OPTION_TEXT = "Choose Option";
    static OPTION_TEXT_NONE = "No organisations available";
    static ADD_ORGANISATION_REQUIRED = "No organisations available - please contact the system administrator";
    static ADD_ORGANISATION_REQUIRED_SYSADMIN = "No organisations available - please add an organisation";
    static APPLY_TEXT = "Apply";
}
